import iconCfm from "../assets/icon-cfm.svg";
import iconPom from "../assets/icon-pom.svg";
import { getEnvConfig } from "./env.config";

export interface ITarget {
  id: string;
  title: string;
  iconSrc: string;
  url: string;
  isEnabled: boolean;
}

export interface ITargetGroup {
  id: string;
  title: string;
  /** Shown between the group heading and its tiles; `""` shows nothing. */
  notice: string;
  targets: ITarget[];
}

// Wording is provisional and awaits confirmation by GRS.
const TARGET_TEXTS = {
  pom: { title: "Inverkehrbringung von Batterien", iconSrc: iconPom },
  cfm: { title: "Batterieabholung", iconSrc: iconCfm },
  stiftung: { title: "Portal der Stiftung GRS", iconSrc: iconPom },
} as const;

export const getTargetGroups = (): ITargetGroup[] => {
  const { pomUrl, cfmUrl, stiftungUrl, noticeText } = getEnvConfig();

  return [
    {
      id: "gmbh",
      title: "GRS Service GmbH",
      notice: noticeText,
      targets: [
        { id: "pom", ...TARGET_TEXTS.pom, url: pomUrl, isEnabled: pomUrl !== "" },
        { id: "cfm", ...TARGET_TEXTS.cfm, url: cfmUrl, isEnabled: cfmUrl !== "" },
      ],
    },
    {
      id: "stiftung",
      title: "Stiftung GRS",
      notice: "",
      targets: [{ id: "stiftung", ...TARGET_TEXTS.stiftung, url: stiftungUrl, isEnabled: stiftungUrl !== "" }],
    },
  ];
};
